import { AlertsSmallFill } from '@elliemae/ds-icons';
import React, { useContext } from 'react';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';

import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { CalendarFooterMessage } from './Styleds.js';
export const CalendarFooter: React.ComponentType = () => {
  const {
    props: { pickerFooterMsg, hasError, readOnly, applyAriaDisabled },
    getProps,
    isWithTimeWheelToo,
  } = useContext(ControlledDateTimePickerContext);
  if (pickerFooterMsg !== undefined && !isWithTimeWheelToo && hasError)
    return (
      <CalendarFooterMessage
        role="alert"
        getOwnerProps={getProps}
        data-testid={ControlledDateTimePickerDatatestid.FOOTERS.CALENDAR}
        $readOnlyStyles={readOnly || applyAriaDisabled}
      >
        <AlertsSmallFill
          width={8}
          height={8}
          color={['danger', '900']}
          style={{ marginRight: '0.5rem', marginBottom: '2px' }}
        />
        {pickerFooterMsg}
      </CalendarFooterMessage>
    );
  return null;
};
